var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showitembeforeadded == "true"
    ? _c("div", [
        _vm.giftitem != null
          ? _c(
              "div",
              {
                staticClass: "basket-list-item py-3 mb-3",
                class: { notgivengift: _vm.currentbasketvalue < _vm.warenwert }
              },
              [
                _vm._t("before-basket-item"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "basket-item component-loading with-icon d-flex"
                  },
                  [
                    _c("div", { staticClass: "image-container" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: _vm.giftitem.images.all[0].urlPreview,
                          loading: "lazy"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-container-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "meta-container-wrapper-inner" },
                        [
                          _c("div", { staticClass: "meta-container" }, [
                            _c(
                              "div",
                              { staticClass: "position-relative w-100" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "item-name text-primary text-appearance  font-weight-bold text-break",
                                    attrs: {
                                      href: _vm._f("itemURL")(_vm.giftitem)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemName")(_vm.giftitem)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.textgiftadd && _vm.giftgiven
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.textgiftadd)
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.textgiftnotadded && _vm.giftgiven != true
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.textgiftnotadded)
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ],
              2
            )
          : _vm._e()
      ])
    : _c("div", [
        _vm.giftitem != null && _vm.currentbasketvalue > _vm.warenwert
          ? _c(
              "div",
              { staticClass: "basket-list-item py-3 mb-3" },
              [
                _vm._t("before-basket-item"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "basket-item component-loading with-icon d-flex"
                  },
                  [
                    _c("div", { staticClass: "image-container" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: _vm.giftitem.images.all[0].urlPreview,
                          loading: "lazy"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "meta-container-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "meta-container-wrapper-inner" },
                        [
                          _c("div", { staticClass: "meta-container" }, [
                            _c(
                              "div",
                              { staticClass: "position-relative w-100" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "item-name text-primary text-appearance  font-weight-bold text-break",
                                    attrs: {
                                      href: _vm._f("itemURL")(_vm.giftitem)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemName")(_vm.giftitem)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.textgiftadd && _vm.giftgiven
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.textgiftadd)
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.textgiftnotadded && _vm.giftgiven != true
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.textgiftnotadded)
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ],
              2
            )
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }